var map = {
	"./0.svg": 637,
	"./1.svg": 638,
	"./10.svg": 639,
	"./11.svg": 640,
	"./12.svg": 641,
	"./13.svg": 642,
	"./14.svg": 643,
	"./15.svg": 644,
	"./16.svg": 645,
	"./17.svg": 646,
	"./18.svg": 647,
	"./19.svg": 648,
	"./2.svg": 649,
	"./20.svg": 650,
	"./3.svg": 651,
	"./4.svg": 652,
	"./5.svg": 653,
	"./6.svg": 654,
	"./7.svg": 655,
	"./8.svg": 656,
	"./9.svg": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;